import { render, staticRenderFns } from "./comOptionsBuilder.vue?vue&type=template&id=2faf1f8e"
import script from "./comOptionsBuilder.vue?vue&type=script&lang=js"
export * from "./comOptionsBuilder.vue?vue&type=script&lang=js"
import style0 from "./comOptionsBuilder.vue?vue&type=style&index=0&id=2faf1f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports